"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlayPosition = void 0;
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_1 = require("react");
var react_2 = require("react");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var useOverlayPosition = function (getOverlayPositionProps) {
    if (getOverlayPositionProps === void 0) { getOverlayPositionProps = {}; }
    var _a = __read((0, react_1.useState)(null), 2), targetElement = _a[0], setTargetElement = _a[1];
    var _b = __read((0, react_1.useState)(null), 2), overlayElement = _b[0], setOverlayElement = _b[1];
    var targetRef = (0, react_2.useCallback)(function (node) { return setTargetElement(node); }, []);
    var overlayRef = (0, react_2.useCallback)(function (node) { return setOverlayElement(node); }, []);
    var _c = __read((0, react_1.useState)(), 2), targetRect = _c[0], setTargetRect = _c[1];
    var _d = __read((0, react_1.useState)(), 2), overlayRect = _d[0], setOverlayRect = _d[1];
    (0, utils_1.useLayoutEffect)(function () {
        if (!targetElement || !overlayElement) {
            return;
        }
        var targetRectObserver = (0, observe_rect_1.default)(targetElement, setTargetRect);
        var overlayRectObserver = (0, observe_rect_1.default)(overlayElement, setOverlayRect);
        targetRectObserver.observe();
        overlayRectObserver.observe();
        return function () {
            targetRectObserver.unobserve();
            overlayRectObserver.unobserve();
        };
    }, [targetElement, overlayElement]);
    var overlayProps = (0, utils_1.getOverlayPosition)(__assign({ targetRect: targetRect, overlayRect: overlayRect }, getOverlayPositionProps));
    return {
        overlayProps: overlayProps,
        overlayRef: overlayRef,
        targetRef: targetRef,
    };
};
exports.useOverlayPosition = useOverlayPosition;
